import styled from 'styled-components';

const MigrateActiveFlex = styled.div`
    display: flex;
    gap: 8px;
    justify-content: center;
    div {
        margin: 0;
    }
`;

export { MigrateActiveFlex };
